import Vue from 'vue'
import VueRouter from 'vue-router'
import VueLodash from 'vue-lodash'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import List from './components/List';
import Scanner from './components/Scanner';
import History from './components/History';
import TicketDetail from './components/TicketDetail';
import store from './store/store';


Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(VueLodash) // options is optional

// 0. If using a module system (e.g. via vue-cli), import Vue and VueRouter
// and then call `Vue.use(VueRouter)`.

// 2. Define some routes
// Each route should map to a component. The "component" can
// either be an actual component constructor created via
// `Vue.extend()`, or just a component options object.
// We'll talk about nested routes later.
const routes = [
  { path: '/list', name: 'list', component: List },
  { path: '/scanner', name: 'scanner', component: Scanner },
  { path: '/history', name: 'history', component: History },
  { path: '/ticket/:id', name: 'ticket', component: TicketDetail },
]

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  routes // short for `routes: routes`
})


new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
